
import { Shield } from "lucide-react";

const AdminHeader = () => {
  return (
    <div className="mb-8 flex items-center gap-4">
      <Shield className="h-8 w-8 text-primary" />
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Admin Panel</h1>
        <p className="text-muted-foreground">
          Manage user premium status for testing
        </p>
      </div>
    </div>
  );
};

export default AdminHeader;
